import React, { Component } from 'react';
import { Modal, Button } from 'react-bootstrap';

export default class Hl7MessageContentRenderer extends Component {
    constructor(props) {
        super(props);

        this.state = {
            show: false
        };
    }

    handleShow = () => {
        this.setState({ show: true });
    };

    handleClose = () => {
        this.setState({ show: false });
    };

    render() {
        const isFailureMessage = this.props.colDef.field === 'failure_message';
        const displayValue = isFailureMessage
            ? this.props.data.failure_message
            : (this.props.value || this.props.data.message_content);
        const modalContent = isFailureMessage
            ? this.props.data.failure_message
            : this.props.data.message_content;
        const modalTitle = isFailureMessage
            ? 'Failure Message'
            : 'HL7 Message Content';

        return (
            <div>
                <button onClick={this.handleShow} className="edit-order-btn">
                    <span>{displayValue}</span>
                </button>
                <Modal
                    size="xl"
                    aria-labelledby="contained-modal-title-vcenter"
                    centered
                    show={this.state.show}
                    onHide={this.handleClose}
                >
                    <Modal.Header closeButton>
                        <Modal.Title>{modalTitle}</Modal.Title>
                    </Modal.Header>
                    <Modal.Body>
                        <div>{modalContent}</div>
                    </Modal.Body>
                    <Modal.Footer>
                        <Button variant="secondary" onClick={this.handleClose}>
                            Close
                        </Button>
                    </Modal.Footer>
                </Modal>
            </div>
        );
    }
}
